import React, { useState, useEffect } from 'react';
import { getApi } from '../services/apiServices';
import { useLanguage } from '../contexts/LanguageContext';
import { useTranslation } from 'react-i18next';

function WhatIsAnEsim() {
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();

  return (
    <>
<section className='faq what-is-esim'>
    <div className="container">

    <div className='row'>
     <div className='col-sm-7'>
     <div className='esim-left-img'>
         <img src="/images/esim-img.png" alt="Footer Logo"></img>
        </div>   
  </div>

 <div className='col-sm-5'>
    <h2 className='e-sim-head'>{t('whatIsEsim.title')}</h2>
<p>{t('whatIsEsim.description')}<br></br>
{t('whatIsEsim.features')}</p>
</div>

    </div>
    </div>

</section>
 </>
  );
}

export default WhatIsAnEsim;
